import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

const DIVISION_ID = '128428';

const ScoreboardTab = () => {
    const [statType, setStatType] = useState('Batters');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLeaderboard = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API_BASE_URL}/leaderboard`, {
                    params: { division_id: DIVISION_ID, season: '2025', type: statType }
                });
                setData(res.data || []);
            } catch (err) {
                console.error("Error fetching scoreboard:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchLeaderboard();
    }, [statType]);

    const styles = {
        wrapper: {
            width: '100%',
            maxWidth: '1232px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
        },
        filterBox: {
            display: 'flex',
            justifyContent: 'center',
            gap: '16px'
        },
        filterBtn: (isActive) => ({
            padding: '8px 24px',
            background: isActive ? '#E7C424' : 'transparent',
            border: `2px solid ${isActive ? '#E7C424' : '#060D8A'}`,
            color: isActive ? '#000' : '#060D8A',
            fontFamily: 'var(--fontRajdhani)',
            fontWeight: 700,
            fontSize: '16px',
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'all 0.3s ease'
        }),
        tableContainer: {
            width: '100%',
            overflowX: 'auto',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily: 'var(--fontRajdhani)',
            minWidth: '800px'
        },
        th: {
            background: '#E7C424',
            color: '#000',
            textAlign: 'left',
            padding: '16px',
            fontWeight: 700,
            fontSize: '18px',
            textTransform: 'uppercase'
        },
        td: {
            padding: '12px 16px',
            borderBottom: '1px solid #eee',
            fontSize: '16px',
            color: '#333'
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.filterBox}>
                <button 
                    style={styles.filterBtn(statType === 'Batters')} 
                    onClick={() => setStatType('Batters')}
                >
                    BATTERS
                </button>
                <button 
                    style={styles.filterBtn(statType === 'Bowlers')} 
                    onClick={() => setStatType('Bowlers')}
                >
                    BOWLERS
                </button>
            </div>

            {loading ? (
                <div className="loader" style={{ margin: '50px auto' }}></div>
            ) : (
                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Rank</th>
                                <th style={styles.th}>Player</th>
                                <th style={styles.th}>Team</th>
                                {statType === 'Batters' ? (
                                    <>
                                        <th style={styles.th}>Runs</th>
                                        <th style={styles.th}>Matches</th>
                                        <th style={styles.th}>Avg</th>
                                        <th style={styles.th}>HS</th>
                                        <th style={styles.th}>100s/50s</th>
                                    </>
                                ) : (
                                    <>
                                        <th style={styles.th}>Wkts</th>
                                        <th style={styles.th}>Matches</th>
                                        <th style={styles.th}>Eco</th>
                                        <th style={styles.th}>Avg</th>
                                        <th style={styles.th}>Best</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? data.map((row, i) => (
                                <tr key={i}>
                                    <td style={styles.td}>{i + 1}</td>
                                    <td style={{ ...styles.td, fontWeight: 700 }}>{row.player_name || `${row.Forename} ${row.Surname}`}</td>
                                    <td style={styles.td}>{row.team_name}</td>
                                    {statType === 'Batters' ? (
                                        <>
                                            <td style={styles.td}>{row.runs}</td>
                                            <td style={styles.td}>{row.matches}</td>
                                            <td style={styles.td}>{row.average}</td>
                                            <td style={styles.td}>{row.high_score}</td>
                                            <td style={styles.td}>{row.hundreds}/{row.fifties}</td>
                                        </>
                                    ) : (
                                        <>
                                            <td style={styles.td}>{row.wickets}</td>
                                            <td style={styles.td}>{row.matches}</td>
                                            <td style={styles.td}>{row.economy}</td>
                                            <td style={styles.td}>{row.average}</td>
                                            <td style={styles.td}>{row.best_bowling}</td>
                                        </>
                                    )}
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="8" style={{ ...styles.td, textAlign: 'center', padding: '40px' }}>
                                        No data available for this selection.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ScoreboardTab;
